

import { useState } from "react";
import MapShow from "../../components/MapShow.js";

import DATA from "../data/_entity.json";

import "../pages/location.css";

const Location = () => {
   const location = DATA.entity.map.coord;
   const gotoLink = DATA.entity.map.link;
   const zoom = 12;

   const [seed, setSeed] = useState(1);
   const reset = () => {
      setSeed(Math.random());
   }

   return (
      <>
         <h2>&nbsp;Location</h2>
         <div className="framer">
            <MapShow key={seed} location={location} zoom={zoom} gotoLink={gotoLink} />
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div className="address-onMap" onClick={reset} onKeyUp={reset} onTouchEnd={reset} title="Click to locate">
               {DATA.entity.address.map((e) => { return <div key={e}> {e} <br /></div> })}
            </div>
         </div>

      </>
   )
}

export default Location;
